import Vue from 'vue'
import Router from 'vue-router'
import { resolve } from '../../config/dev.env'
import agent from './agent'
import notaryoffice from './notaryoffice'
import financial from './financial'
import system from './system'
import store from '../store'

/**
 * 重写路由的push方法
 */
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

Vue.use(Router)

const router = new Router({
  mode: 'history',
  // base: './',
  routes: [
    {
      path: '/',
      name: 'login',
      redirect: '/login'
    },
    {
      path: '/readme',
      name: '首页',
      component: resolve => require(['../components/common/Home'], resolve),
      children: [
        ...system,
        ...agent,
        ...financial, // 财务菜单
        ...notaryoffice, // 公证员菜单
        // 公证处信息管理
        {
          path: '/NotaryOffice',
          name: '公证处信息管理',
          component: resolve => require(['../components/NotaryOffice/ShowNotaryOffice'], resolve)
        },

        {
          path: '/case',
          name: '案件列表',
          redirect: '/case/CaseApproval'
        },
        // 案件审批
        {
          path: '/case/CaseApproval',
          name: '案件列表',
          component: resolve => require(['../components/CaseApproval/ShowCaseInfo'], resolve)
        },
        {
          path: '/Approval/CaseDetail',
          name: '案件审批',
          component: resolve => require(['../components/CaseApproval/CaseDetail'], resolve)
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: resolve => require(['../components/page/login'], resolve)
    },
    {
      path:'/loginforO',
      name:'loginforO',
      component:resolve => require(['../components/page/loginforO'],resolve)
    },
    {
      path:'/notarizationDownload',
      name:'notarizationDownload',
      component:resolve=>require(['../components/MNR/notarizationDownload'],resolve)
    },
    { path: '*', component: resolve => require(['../components/page/NotFound'], resolve) }
  ]
})

const someRoute = (path, routers) => {
  return routers.some(s => {
    let result = s.path === path
    if(!result && s.children) {
      return someRoute(path, s.children);
    }
    return result
  })
}

// router.beforeEach((to, from, next) => {
//   // 路由权限处理
//   const routers = store.getters.getRoute;
//   if(someRoute(to.path, routers)) {
//     next();
//   } else if(to.path != '/login' && to.path != '/404') {
//     next({path: '/404'});
//   } else {
//     next();
//   }
// });

export default router



// WEBPACK FOOTER //
// ./src/router/index.js